<template>
  <div id="modalp-template">
    <div class="modalp-mask">
      <div class="modalp-wrapper">
        <div class="modalp-container">
          <div class="modalp-close-button" @click="$emit('close')">X</div>
          <div class="modalp-body-body">
            <slot name="body">
              <AlcoholAndHealth v-if="wichModal === 'alcoholandhealth'" name="millerlite" />
            </slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AlcoholAndHealth from "@/components/AlcoholAndHealth";

export default {
    name: "ModalAH",
    components: {
        AlcoholAndHealth,
    },
    props: {
       wichModal: {
         type: String,
         default: "none"
        }
    }
    
}
</script>

<style lang="stylus" scoped>
@import 'ModalAH.styl';
</style>